// pages/FormViewerPage/services/formViewerService/funnelMeta.ts — event funnel Meta (split dari funnelEvents.ts)
import type { FunnelEventParams } from './funnelTypes';
import { alreadyFired } from './funnelSession';
import { ensureFbq } from '../../../../utils/pixelGate';

// Satu pintu loader (utils/pixelGate). Event funnel = sinyal user intent
// (klik CTA) → BYPASS gate sukses-load, fire langsung.
function ensureFbqStub(): boolean {
    ensureFbq();
    return true;
}

// userData = RAW record (Meta auto-hash) utk argumen init ke-3. WAJIB di-thread
// dari caller yg punya data (FormView/AddToCart): init pertama menang, jadi
// siapa pun yg init duluan harus bawa data — kalau tidak, matching hilang.
function initPixels(pixelIds: string[], userData?: Record<string, string>): void {
    const w = window as any;
    if (!(w._our_fbq_inited instanceof Set)) w._our_fbq_inited = new Set<string>();
    const inited: Set<string> = w._our_fbq_inited;
    pixelIds.filter(id => id?.trim()).forEach(id => {
        if (!inited.has(id)) {
            inited.add(id);
            try { w.fbq('init', id, userData); } catch { /* abaikan */ }
        }
    });
}

// Tembak 1 event funnel Meta ke semua pixel ID. Idempoten per sesi tab.
// eventID = sessionKey agar Meta dedup lintas-origin (LP statis di host lain
// fire event yang sama dengan kunci yang sama — Meta menyimpan yang pertama).
export function fireFunnelMetaEvent(
    pixelIds: string[],
    eventName: 'AddToCart' | 'InitiateCheckout',
    params: FunnelEventParams,
    sessionKey: string,
    userData?: Record<string, string>
): boolean {
    try {
        if (!pixelIds || pixelIds.length === 0) return false;
        if (alreadyFired(sessionKey)) return false;
        if (!ensureFbqStub()) return false;
        initPixels(pixelIds, userData);
        (window as any).fbq('track', eventName, {
            content_type: 'product',
            currency: 'IDR',
            ...params,
        }, { eventID: sessionKey });
        return true;
    } catch { return false; }
}

export { ensureFbqStub, initPixels };
